import React from "react";

export const NotificationReport = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="20" cy="20" r="20" fill="#65D4E2" />
      <g clipPath="url(#clip0_34647_2698)">
        <path
          d="M29.7207 13.7035L25.1242 9.18848C25.0011 9.06763 24.8351 9 24.6624 9H13.0416C11.6855 9 10.582 10.1031 10.582 11.4592V29.0404C10.582 30.3966 11.6855 31.5 13.0416 31.5H27.4584C28.8145 31.5 29.918 30.3966 29.918 29.0404V14.1737C29.918 13.9965 29.8467 13.8275 29.7207 13.7035Z"
          fill="white"
        />
        <path
          d="M29.918 14.1737V29.0404C29.918 30.3966 28.8145 31.5 27.4584 31.5H20.25V9H24.6624C24.8351 9 25.0011 9.06763 25.1242 9.18848L29.7207 13.7035C29.8467 13.8275 29.918 13.9965 29.918 14.1737Z"
          fill="#F0F0F0"
        />
        <path
          d="M25.4856 20.1182C25.4856 20.4821 25.1901 20.7773 24.8264 20.7773H15.5342C15.1703 20.7773 14.875 20.4821 14.875 20.1182C14.875 19.7539 15.1703 19.459 15.5342 19.459H24.8264C25.1901 19.459 25.4856 19.7539 25.4856 20.1182Z"
          fill="#F0F0F0"
        />
        <path
          d="M23.77 22.7549C23.77 23.1188 23.4745 23.4141 23.1108 23.4141H15.534C15.1703 23.4141 14.875 23.1188 14.875 22.7549C14.875 22.3906 15.1703 22.0957 15.534 22.0957H23.1108C23.4747 22.0957 23.77 22.3906 23.77 22.7549Z"
          fill="#F0F0F0"
        />
        <path
          d="M24.6839 25.3916C24.6839 25.7555 24.3886 26.0508 24.0247 26.0508H15.534C15.1703 26.0508 14.875 25.7555 14.875 25.3916C14.875 25.0273 15.1703 24.7324 15.534 24.7324H24.0247C24.3886 24.7324 24.6839 25.0273 24.6839 25.3916Z"
          fill="#F0F0F0"
        />
        <path
          d="M29.9179 14.1737V14.8329H25.5311C24.6888 14.8329 24.0032 14.1473 24.0032 13.3049V9H24.6624C24.835 9 25.0012 9.06763 25.1241 9.18848L29.7207 13.7035C29.8467 13.8275 29.9179 13.9965 29.9179 14.1737Z"
          fill="#B4B4B7"
        />
        <path
          d="M23.1107 23.4141H20.25V22.0957H23.1107C23.4747 22.0957 23.7699 22.3906 23.7699 22.7549C23.7699 23.1188 23.4747 23.4141 23.1107 23.4141Z"
          fill="#D2D2D2"
        />
        <path
          d="M24.6838 25.3916C24.6838 25.7555 24.3886 26.0508 24.0247 26.0508H20.25V24.7324H24.0247C24.3886 24.7324 24.6838 25.0273 24.6838 25.3916Z"
          fill="#D2D2D2"
        />
        <path
          d="M25.4855 20.1182C25.4855 20.4821 25.1901 20.7773 24.8263 20.7773H20.25V19.459H24.8263C25.1901 19.459 25.4855 19.7539 25.4855 20.1182Z"
          fill="#D2D2D2"
        />
      </g>
      <defs>
        <clipPath id="clip0_34647_2698">
          <rect
            width="22.5"
            height="22.5"
            fill="white"
            transform="translate(9 9)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
